import { CreditReviewStatus } from '@40seas/entities/credit-reviews';
import { EnumColor } from '@40seas/frontend/common/providers';

export const creditReviewStatusColorMapping = {
    [CreditReviewStatus.Ready]: 'info',
    [CreditReviewStatus.InProgress]: 'default',
    [CreditReviewStatus.Failed]: 'error',
    [CreditReviewStatus.Pending]: 'default',
} as { [key in CreditReviewStatus]: EnumColor };
